import 'slick-carousel';

jQuery( document ).ready(function($) {
    $('.hero-carousel').slick({
        dots: true,
        arrows: false
    });
    $("iframe[src*='youtube']").wrap("<div class='media-responsive'/>");

    $('.menu-toggle').on('click', function(e){
        e.preventDefault();
        $('.menu-wrapper').toggleClass('open');
        $('.menu-toggle').toggleClass('open');
        
        $('.search-wrapper').removeClass('open');
    })
    
    $('.search-toggle').on('click', function(e){
        e.preventDefault();
        $('.search-wrapper').toggleClass('open');
        
        $('.menu-wrapper').removeClass('open');
        $('.menu-toggle').removeClass('open');
    })
});